<template>
  <div class="diadin">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input style="width: 300px;" clearable :placeholder="`${$t('menu.OrderNumber')}/ ${$t('menu.chejiahao')}`"
          v-model="formInline.title"></el-input>
      </el-form-item>
      <el-form-item >
          <el-select filterable  v-model="formInline.data1" :placeholder="$t('menu.zcmxlsh')" clearable>
            
            <el-option v-for="(item,index) in lslis" :key="index" :label="item.dealerName" :value="item.id"></el-option>
         
          </el-select>
        </el-form-item>
        
      
      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ $t('menu.search') }}</el-button>
        <!-- <el-button>重置</el-button> -->
      </el-form-item>
         <el-button type="primary" @click="dk">{{ $t('menu.shengchengpeiqdan') }}</el-button>
      
    </el-form>
    <div class="bonntbot">
      <el-tabs v-model="action" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in staue" :key="index"
          :label="item.num > 0 ? item.name + '(' + item.num + ')' : item.name" :name="item.id"></el-tab-pane>


      </el-tabs>
      <div class="bonntbota">
     
      </div>

    </div>
   
    <el-table  empty-text=" " :data="mation" style="width: 100%" border highlight-current-row @selection-change="handleSelectionChange">
      <el-table-column  v-if="action=='0'" :selectable="selectable" type="selection" width="70">
      </el-table-column>
      <el-table-column prop="pc" :label="$t('menu.ClaimNumber')"  width="200">
        <template slot-scope="scope">
        <div>  {{ scope.row.claimNumber }}</div>
          </template>
      </el-table-column>
      <el-table-column prop="dearerId" :label="$t('menu.zcmxlsh')">
        <template slot-scope="scope">
         <div>
          <div> {{pdlsh(scope.row.dearerId)  }}</div>
          <div> {{pdlsha(scope.row.dearerId)  }}</div>
         </div>
        </template>
      </el-table-column>
      <el-table-column prop="vin" :label="$t('menu.chejiahao')"  ></el-table-column>
      <el-table-column prop="partNumber" :label="$t('menu.cgwdpjbm')" > </el-table-column>
      <el-table-column prop="partName" :label="$t('menu.PartName')">
        <template slot-scope="scope">
          <div v-if="inle=='zh'">
           {{ scope.row.partName }}
          </div>
          <div v-else>
             {{ scope.row.partNameEn }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" :label="$t('menu.suopeishukl')">  </el-table-column>
      <el-table-column prop="orderQuanity" :label="$t('menu.yipeifusl')"> 
          <template slot-scope="scope">
       
              {{ scope.row.orderQuanity==null?0:scope.row.orderQuanity }}
        
            </template> </el-table-column>
        <el-table-column prop="quantity" :label="$t('menu.dipeifusl')"> 
           <template slot-scope="scope">
          <div v-if="scope.row.orderQuanity!==null">
              {{ scope.row.quantity-scope.row.orderQuanity }}
          </div>
            <div v-else>
              {{ scope.row.quantity}}
            </div>
            </template>
           </el-table-column>
           <el-table-column   prop="poNum" :label="$t('menu.xiaoshoudh')"> 
             <template slot-scope="scope">
          <div v-if="scope.row.poNum!==null">
              {{ scope.row.poNum }}
          </div>
            <div v-else>
             -
            </div>
            </template>
             </el-table-column>
      <el-table-column prop="status" :label="$t('menu.State')" width="80">
        <template slot-scope="scope">
          {{ formatStatus(scope.row.status) }}
        </template>
      </el-table-column>
     
    
    </el-table>
 

    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total,sizes, prev, pager, next" :total="totale">
      </el-pagination>
    </div>

    <el-dialog
      :title="$t('menu.chuangjianxiaosd')"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose">
      <div>
        <div style="display: flex;width: 100%;">
    
          <div style="width: 50%;display: flex;align-items: center;"><div style="width: 70px;">{{$t('menu.zcmxlsh')}}：</div> {{pdlsh(formInline.data2)  }}</div>
          <div style="display: flex;align-items: center;">
            <div style="width: 100px;">{{$t('menu.ExpectedShippingdate')}}:</div>
           <el-date-picker v-model="item2" type="date" value-format="yyyy-MM-dd" :placeholder="$t('menu.fhdfhsj')">
        </el-date-picker>  
          </div>
        </div>
        <div style="margin-top: 20px;display: flex;">
            <div style="width: 70px;">{{$t('menu.Remarks')}}：</div>
          <el-input placeholder=""  v-model="userRemarks" type="textarea" :rows="4"></el-input>
        </div>
      </div>
      <div>
        <div style="margin:  20px 0;">{{$t('menu.peijianmingxi')}}：</div>
        <div>
           <el-table  empty-text=" " :data="zclist" style="width: 100%" height="200" border highlight-current-row > 
              <el-table-column prop="partNumber" :label="$t('menu.cgwdpjbm')" > </el-table-column>
              <el-table-column prop="partName" :label="$t('menu.PartName')">
                <template slot-scope="scope">
                  <div v-if="inle=='zh'">
                   {{ scope.row.partName }}
                  </div>
                  <div v-else>
             {{ scope.row.partNameEn }}
                 </div>
               </template>
             </el-table-column>
               <el-table-column prop="quantity" :label="$t('menu.dipeifusl')"> 
                  <template slot-scope="scope">
                 <div v-if="scope.row.orderQuanity!==null">
                     {{ scope.row.quantity-scope.row.orderQuanity }}
                 </div>
                   <div v-else>
                     {{ scope.row.quantity}}
                   </div>
                   </template>
                  </el-table-column>
             <el-table-column prop="quantity" :label="$t('menu.bencipeifus')" >
               <template slot-scope="scope">
                 <el-input  v-model="scope.row.quantity"></el-input>
               </template>
             </el-table-column>
           
    
           </el-table>
           <div>{{$t('menu.peijianzongs')}}：{{ zclist.length }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{$t('menu.Cancel')}}</el-button>
        <el-button type="primary" @click="updata">{{$t('menu.Confirm')}}</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
import { pomyPos,getInfo,cartCoOfDealerlista, querytype, pageSumMyPo, exportMyPo, exportMyPoDetails,retailerlist } from '../../api/api'
import roleaVue from '../user/rolea.vue'

export default {
  data () {
    return {
      action: '0',
      dialogVisible:false,
      userRemarks:'',
      item2:'',
      staue: [
        {
          name: this.$t('menu.dailipei') ,
          num: 0,
          id: '0',
        },
        {
          name: this.$t('menu.yilipei'),
          num: 0,
          id: '1',
        },
        {
          name: this.$t('menu.quxiaolip'),
          num: 0,
          id: '2',
        }],
      jsfs: [],
      currentPage3: 1,
      pagesize: 10,
      totale: 3,
      orderType:'',
      mation: [], //列表
      formInline: {
        title: '',
        startTime: '',
        endTime: '',
        contact: '',
        category: '',
        type: '',
        staue: '',
        data1: '',
        data2: '',
        
      },
      inle: 'zh',
      odtype:'',
      lslis:[],
      zclist:[],
      userId:'',
    }
  },
  created () {
    let a = sessionStorage.getItem('i18n')
    this.inle = a
    this.querytyp()
    this.action = '0'
    this.biao()
    this.geeeeeetif()
  },
  methods: {
    geeeeeetif(){
      getInfo().then(r => {
        if (r.data.code == 200) {
          this.userId = r.data.user.dealers[0].accTypeIdLs
        
        }
      })
    },
     //判断勾选
        selectable(row, index) {
          console.log(123222123, this.zclist.length);
          
          if(   this.zclist.length<1 ){
             return true;
          }else{
            if (this.zclist[0].dearerId==row.dearerId) {
                return true;
            } else {
                return false;
            }
          }
       
            
        },
    pdlsh(e){
      let a =this.lslis
      let c= ''
      a.forEach(z=>{
          if(z.id==e){
            c=z.dealerName
          }
      })
      return c 
    },
    

     pdlsha(e){
      let a =this.lslis
      let c= ''
      a.forEach(z=>{
          if(z.id==e){
            c=z.dealerNameFull
          }
      })
      return c 
    },
    handleClose(){
      this.dialogVisible=false
      this.userRemarks=''
      this.item2=''
    },
    dk(){
      if(this.zclist.length>0){
        this.dialogVisible=true
      }else{
          this.$message.error('请选择配件');
      }
      
    },
    //下单
    async updata () {
     
     if(this.zclist.length>0){
      let a = []
      
      let cc = []
        this.zclist.forEach(e=>{
          a.push(e.id)
          cc.push(e.quantity)
        })
       this.zclist
        let param = new URLSearchParams();
        let retailerId = this.zclist[0].dearerId
        let address = ''
        
        let cardId = a
        let cardQuanity =cc
        let paymentMethod = 'co'
        let priceTerms = 'FOB'
        let shippingMethod = 'KD'
        let userRemarks = this.userRemarks
        let shippingDate = this.item2 ? this.item2 + ' 00:00:00' : ''
        // let shippingDate = this.shippingDate ? this.shippingDate + ' 00:00:00' : ''
       
        
        let b = ''
       
        a.forEach((e, i) => {
          let c = ''
          if (i == 0) {
            c = '&cardId=' + e
          } else {
            c = '&cardId=' + e
          }
          b = b + c
        })
        let bb = ''
       
        cc.forEach((e, i) => {
          let x = ''
          if (i == 0) {
            x = '&cardQuanity=' + e
          } else {
            x = '&cardQuanity=' + e
          }
          bb = bb + x
        })
      //  order order2Next
        let cca =this.common.httpUrl+'/aps/cartCoOfDealer/order?retailerId=' + retailerId + '&address=' + address + b +bb+ '&paymentMethod=' + paymentMethod + '&priceTerms=' + priceTerms + '&shippingMethod=' + shippingMethod + '&userRemarks=' + userRemarks + '&shippingDate=' + shippingDate+'&accTypeId='+ this.userId+'&currencyType='+this.zclist[0].currencyType
        
            this.$http.get(cca,
              {
            'headers': {
              'authorization': sessionStorage.getItem('token')
            }
          })
          .then(async response => {
            // 处理响应数据
            if (response.data.code == 200) {
              this.biao()
              this.$message.success('制单成功');
              this.handleClose()

            } else {
              this.$message.error(response.data.msg);
             
            }
          })
          .catch(error => {
           
          });



     }else{
        this.$message.error('请选择配件');
        return false
     }
  
    },
   
    async biao () {
      let a = ''
      if (this.action == '99') {
        a = ''
      } else {
        a = this.action
      }
      console.log(123123,this.orderType);
        let status = a
        // if(this.action=='0'){
        //   this.pagesize=100
        // }else{
        //   this.pagesize=10
        // }
         let param = new URLSearchParams()
      let parama ='?pageNum=' +  this.currentPage3+'&pageSize='+this.pagesize+'&status='+status+'&searchValue='+this.formInline.title+'&dearerId='+this.formInline.data1
    
      const { data: res } = await cartCoOfDealerlista(param,parama )

     console.log(res);
     
 this.mation = res.rows
 this.totale=res.total
 if(res.summary.length>0){
    res.summary.forEach(ez=>{
  this.staue.forEach(ea=>{
    if(ez.status==ea.id){
      ea.num=ez.sum
    }
 })
 })
 }

console.log(123123, this.mation); 
      this.lsslist()
   
      // this.numlist()
    },
    async numlist () {

      let param = {}
      const { data: res } = await pageSumMyPo(param)
      let a = this.staue
      let b = 0
      let c = 0
      res.data.forEach(e => {
        a.forEach((z, i) => {
          if (e.status == z.id) {
            this.staue[i].num = e.sum
          } else {
            if (e.status == 5) {
              console.log(1);

              b = e.sum
            }
            if (e.status == 1) {
              console.log(1);

              c = e.sum
            }
          }


        })


      })
      this.staue[1].num = b + c
    },
   async lsslist(){
      
        let param = new URLSearchParams()
      const { data: res } = await retailerlist(param, 1,500)
      console.log(res.rows);
    this.lslis=res.rows
      
    },


    handleSelectionChange (e) {
      console.log(e);
      this.zclist=e
      this.formInline.data2=this.zclist[0].dearerId
      
     },
    async querytyp () {
      let param = new URLSearchParams()
      const { data: res } = await querytype(param, 't_po_payment_method')
      this.jsfs = res.data
      this.jsfs.unshift({
        dictLabel: this.$t('menu.All'),
        dictValue: '',
        dictLabelEn: this.$t('menu.All'),
      })
      this.odtype=[
        {
          dictLabel: this.$t('menu.All'),
        dictValue: '',
        dictLabelEn: this.$t('menu.All'),
        },
        { 
          dictLabel: this.$t('menu.Partsorder'),
        dictValue: '1',
        dictLabelEn: this.$t('menu.Partsorder'),
        },
        {
          dictLabel: this.$t('menu.Vehicleorder'),
        dictValue: '2',
        dictLabelEn: this.$t('menu.Vehicleorder'),
        },
      ]
    },
    handleClick (tab, event) {
      this.action = tab.name
      this.biao()
      // console.log(tab, event)
    },
    //表单点击
    handleEdit (index, row) {
      let a = sessionStorage.getItem('name')
      let b = sessionStorage.getItem('namef')
      sessionStorage.setItem('namefac1',a )
      sessionStorage.setItem('namefac2',b )
      let cc  =sessionStorage.getItem('i18n')
      if (cc == 'zh') {
        sessionStorage.setItem('name', '订单详情')
        sessionStorage.setItem('namef', 'Details')

      } else {
        sessionStorage.setItem('name', 'Details')
        sessionStorage.setItem('namef', '订单详情')
      }
    
      this.$router.push({
        path: '/orderDetails',
        query: {
          vin: row.vin,
          type: index,
          orderNumber: row.po.orderNumber,
        },
      })
    },
    //tab切换
    tabclick (i) {
      console.log(i);

      // this.action = i
      // this.biao()
    },

    //搜索
    onSubmit () {
      this.biao()
    },

    handleSizeChange (val) {
      this.pagesize = val
      console.log(`每页 ${val} 条`)
      this.biao()
    },
    handleCurrentChange (val) {
      this.currentPage3 = val
      this.biao()
    },
    jstype (e) {
      let c = ''
      let a = this.jsfs
      a.forEach((z) => {
        if (e == z.dictValue && this.inle == 'zh') {
          c = z.dictLabel
        }
        if (e == z.dictValue && this.inle !== 'zh') {
          c = z.dictLabelEn
        }
      })
      return c
    },
    formatStatus (status) {
      if (status == 0) {
        return this.$t('menu.dailipei')
      } else if (status == 1) {
        return this.$t('menu.yilipei')
      } else if (status == 2) {
        return this.$t('menu.quxiaolip')
      } 
    },
  },
}
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 10px;


  position: relative;


}

.bonntbota {
  position: absolute;
  right: 10px;
  top: 0;
}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-table th.is-leaf {
  text-align: left;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}

/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.actio {
  color: #409eff;
  font-size: 16px;
  font-weight: 600;
}
</style>
